<template>
  <div class="layout-occupants">
    <layout-default :group="groupSegments(sectionTitles[0])" :pageData="pageData"></layout-default>
    <layout-horizontal :group="groupSegments(sectionTitles[1])" :pageData="pageData"></layout-horizontal>
  </div>
</template>

<script>
import LayoutHorizontal from '@/components/presentational/layouts/LayoutHorizontal';
import LayoutDefault from '@/components/presentational/layouts/LayoutDefault';

export default {
  props: ['group', 'pageData', 'sectionTitles'],
  inject: ['$validator'],
  components: {
    LayoutHorizontal,
    LayoutDefault,
  },
  methods: {
    /**
     * Returns only the sections in the group whose index is in `sectionTitles`.
     */
    groupSegments(sectionTitles) {
      const groupSegments = [];

      Object.keys(this.group).forEach((groupSegment, i) => {
        if (sectionTitles.indexOf(i) !== -1) {
          groupSegments[groupSegment] = this.group[groupSegment];
        }
      });

      return groupSegments;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/presentational/layouts/LayoutOccupants.vue?4feeedb4